import React from 'react';
import { Box } from '@mui/system';

interface EndConditionPatternButtonProps {
  readonly src: string;
  readonly alt: string;
  readonly onClick: () => void;
  readonly isSelected: boolean;
  readonly index?: number;
}

function EndConditionPatternButton({ src, alt, onClick, isSelected, index }: EndConditionPatternButtonProps) {
  return (
    <Box component="div" sx={[{ cursor: 'pointer', width: 75, height: 75, m: 1 }]} onClick={onClick}>
      <Box
        component="img"
        sx={[
          {
            cursor: 'pointer',
            width: 75,
            height: 75,
            position: 'relative',
          },
          isSelected ? { outline: '3px solid', outlineColor: 'primary.main', borderRadius: '10%' } : null,
        ]}
        src={src}
        alt={alt}
      />
      {index ? (
        <p
          style={{
            border: 'none',
            background: 'transparent',
            marginTop: '-78px',
            marginLeft: '8px',
            position: 'relative',
            fontSize: '16.65px',
          }}
        >
          {index}
          {alt === 'Advanced' ? (
            <>
              <br />
              CUSTOM
            </>
          ) : null}
        </p>
      ) : null}
    </Box>
  );
}

export default EndConditionPatternButton;
